import styled from 'styled-components'

export const MainStyle = styled.div`
  flex-grow: 1;
`
